import React from "react";
import PhoneInput from "react-country-phone-input";
import "react-phone-input-2/lib/style.css";

export function phoneDigitsOnly(raw) {
  return String(raw || "").replace(/\D/g, "");
}

/** Stable key for directory doc ids (US 10-digit NANP normalized with leading 1). */
export function phoneFingerprintForDirectoryId(raw) {
  const digits = phoneDigitsOnly(raw);
  if (!digits) return "";
  if (digits.length === 10) {
    const a = digits[0];
    if (a >= "2" && a <= "9") return `1${digits}`;
    return digits;
  }
  if (digits.length === 11 && digits[0] === "1") return digits;
  return digits;
}

/**
 * Country-aware phone field (react-country-phone-input + react-phone-input-2 styles).
 * `value` / stored strings may be formatted; the control normalizes digits internally.
 */
export function KeyContactPhoneField({ value, onChange, disabled, inputProps }) {
  return (
    <PhoneInput
      country="us"
      enableSearch
      specialLabel=""
      value={phoneDigitsOnly(value)}
      disabled={disabled}
      onChange={(_digits, _country, _e, formattedValue) => {
        onChange(formattedValue ?? "");
      }}
      containerStyle={{ width: "100%" }}
      inputStyle={{ width: "100%" }}
      inputProps={inputProps}
    />
  );
}
